





















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

/**
 *  The bare modal component, only providing a modal with background
 *  and the possibility of adding a fixed header and footer.
 */
@Component
export default class Modal extends Vue {

    public $refs!: {
        header: HTMLElement;
        content: HTMLElement;
        footer: HTMLElement;
    };

    @Prop({ type: String, default: '25rem' })
    private width!: string;

    @Prop({ type: Boolean, default: false })
    private hideClose!: boolean;

    @Prop({ type: Boolean, default: false })
    private nonClosable!: boolean;

    @Prop({ type: Array })
    private paddingless!: Array<string>;

    /**
     *  Holding the current open state.
     */
    private opened = false;

    /**
     *  Used to open the modal.
     */
    public open(): void {

        this.opened = true;

        this.$nextTick(this._computeContentMargin);

    }

    /**
     *  Used to add or remove the event listener
     *  for computing the content margin.
     */
    @Watch('opened')
    private updateEventListener(open: boolean): void {

        window[open ? 'addEventListener' : 'removeEventListener']('resize', this._computeContentMargin);

    }

    /**
     *
     *  Used to close the modal.
     *
     *  (i) Emits a `close` event before actually closing
     *
     *  @param force If the modal should be forced closed,
     *  even though `non-closable` is set to true
     *
     */
    public close(force?: boolean): void {

        if (force === true) {

            this.$emit('close');

            this.opened = false;

            return;

        }

        if (this.nonClosable) {

            return;

        }

        this.$emit('close');

        this.opened = false;

    }

    /**
     *
     *  Used to compute the top and bottom padding of the modal's content.
     *
     *  (i) The content needs a top padding to get out from under the fixed
     *  header, and a bottom padding to get out from under the fixed footer.
     *
     *  (i) The header and footer need to be fixed to ensure they stay
     *  in the viewport on scroll
     *
     */
    private _computeContentMargin(): void {

        if (this.$refs.header) {

            this.$refs.content.style.paddingTop = `${ this.$refs.header.clientHeight }px`;

        }

        if (this.$refs.footer) {

            this.$refs.content.style.paddingBottom = `${ this.$refs.footer.clientHeight }px`;

        }

    }

}
